import type { Lang } from "../domain";

const reasons: Record<string, { ar: string; en: string }> = {
  SPAM: { ar: "محتوى مزعج", en: "Spam" },
  HARASSMENT: { ar: "مضايقة", en: "Harassment" },
  HATE_SPEECH: { ar: "خطاب كراهية", en: "Hate speech" },
  VIOLENCE: { ar: "عنف", en: "Violence" },
  NUDITY: { ar: "عُري", en: "Nudity" },
  FALSE_INFORMATION: { ar: "معلومات مضللة", en: "False information" },
  OTHER: { ar: "سبب آخر", en: "Other" },
};

export function reportReason(reason: string, lang: Lang): string {
  return reasons[reason.trim().toUpperCase()]?.[lang] ?? reason;
}
